var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseBlueIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0792 8.17678L15.6464 13.744L13.744 15.6464L8.17678 10.0792L8 9.90245L7.82322 10.0792L2.256 15.6464L0.353554 13.744L5.92078 8.17678L6.09755 8L5.92078 7.82322L0.353553 2.256L2.256 0.353553L7.82322 5.92078L8 6.09755L8.17678 5.92078L13.744 0.353554L15.6464 2.256L10.0792 7.82322L9.90245 8L10.0792 8.17678Z",
    fill: "#1976D2",
    stroke: "white",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseBlueIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/closeBlueIcon.50d136cf7c4dd1bc96322a7b75080c66.svg";